import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {delayInMinutes, etaInMinutes} from "./components/timeUtils";

export function StopStatusInfo({eta}: {eta: string}) {
    const {formatRelativeTime, formatTime} = useIntl();
    const inMinutes = etaInMinutes(eta);
    if (inMinutes == null || eta == null) {
        return null;
    } else if (inMinutes <= -1) {
        return (
            <div>
                <FormattedMessage id="delay" /> {delayInMinutes(eta)} min
            </div>
        );
    } else if (inMinutes <= 0) {
        return (
            <div>
                <FormattedMessage id="soon" />
            </div>
        );
    } else if (inMinutes <= 10) {
        return <div>{formatRelativeTime(inMinutes, "minute", {style: "short"})}</div>;
    } else {
        return <div>{formatTime(new Date(eta))}</div>;
    }
}
